import { WalkthroughStep } from "../../../common/components/walkthroughV2/useWalkthrough";
import { PagedUserModel } from "../../users-facility/api/types";
import { PagedUserManagementModel } from "./types";

export const pageWalkthroughSteps: WalkthroughStep[] = [
  //0
  {
    title: "Group Admins",
    caption:
      "Allows a group admin to view a list of all co-group admins, including their details and status. You may also be able to invite new admins, edit profiles, lock/unlock accounts, and manage each admin's access permissions.",
    highlights: [{ id: "group-admin-data-table" }],
  },
  //1
  {
    title: "Search",
    caption:
      "Click the search field → type an Admin name (full or partial). Press enter or click the magnifying glass to filter.",
    highlights: [{ id: "group-admin-search-bar" }],
  },
  //2
  {
    title: "Invite New Admin",
    caption:
      'Invite a new co-group admin by clicking the "Invite Co-Group Admin" button.',
    highlights: [{ id: "group-admin-invite-button" }],
    delayAfterNext: 300,
  },
  //3
  {
    title: "Invite New Admin",
    caption:
      "Search by name or email address to check if the user already exists. If not, you can create a new account.",
    highlights: [{ id: "invite-user-search-modal" }],
  },
  //4
  {
    title: "Invite New Admin",
    caption:
      "Select the matching active user to proceed, or click Ignore to invite a new one of there are not matches.",
    highlights: [{ id: "invite-user-search-modal" }],
    delayAfterNext: 1500,
  },
  //5
  {
    title: "Invite New Admin",
    caption:
      "Update the user's info if needed, then click Save to send login details to their email.",
    highlights: [{ id: "group-admin-user-dialog" }],
    delayAfterNext: 600,
  },
  //6
  {
    title: "Walkthrough Icon",
    caption: `Tip: If you accidentally close this walkthrough, just click the ℹ️ (Info) icon anytime to start it again from the beginning.`,
    highlights: [{ id: `group-admin-walkthrough-start-button` }],
  },
];

export const dummyPagedUserManagement: PagedUserManagementModel = {
  items: [
    {
      id: "1",
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      phone: "+1234567890",
      lastLoginAt: new Date("2024-06-01T10:00:00Z"),
      roles: ["user"],
      role: "user",
      applicationUserId: "app-1",
      photoUrl: "https://randomuser.me/api/portraits/women/1.jpg",
      isAdminLocked: false,
      department: 6,
    },
    {
      id: "2",
      name: "Bob Smith",
      email: "bob.smith@example.com",
      phone: "+1987654321",
      lastLoginAt: new Date("2024-06-02T12:30:00Z"),
      roles: ["admin"],
      role: "admin",
      applicationUserId: "app-2",
      photoUrl: "https://randomuser.me/api/portraits/men/2.jpg",
      isAdminLocked: true,
      adminLockingReason: "Suspicious activity detected",
      department: 4,
    },
    {
      id: "3",
      name: "Charlie Lee",
      email: "charlie.lee@example.com",
      phone: "+1122334455",
      lastLoginAt: new Date("2024-06-03T09:15:00Z"),
      roles: ["user", "editor"],
      role: "editor",
      applicationUserId: "app-3",
      photoUrl: "https://randomuser.me/api/portraits/men/3.jpg",
      isAdminLocked: false,
      department: 5,
    },
  ],
  pageNumber: 1,
  pageSize: 10,
  totalItems: 3,
  searchText: "",
};

// ...existing code...

// ...existing code...

export const dummyPagedUserModel: PagedUserModel = {
  items: [
    {
      id: "1",
      photoUrl:
        "https://images.pexels.com/photos/3992656/pexels-photo-3992656.png",
      email: "alice@example.com",
      emailConfirmed: true,
      lastName: "Johnson",
      firstName: "Alice",
      civilStatus: 1,
      gender: 2,
      twoFactorEnabled: false,
      isAdminLocked: "false",
      fullName: "Alice Johnson",
    },
    {
      id: "2",
      photoUrl:
        "https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg",
      email: "bob@example.com",
      emailConfirmed: true,
      lastName: "Smith",
      firstName: "Bob",
      civilStatus: 2,
      gender: 1,
      twoFactorEnabled: true,
      isAdminLocked: "true",
      adminLockingReason: "Suspicious activity",
      fullName: "Bob Smith",
    },
    {
      id: "3",
      photoUrl:
        "https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg",
      email: "charlie@example.com",
      emailConfirmed: false,
      lastName: "Lee",
      firstName: "Charlie",
      civilStatus: 1,
      gender: 1,
      twoFactorEnabled: false,
      isAdminLocked: "false",
      fullName: "Charlie Lee",
    },
  ],
  pageNumber: 1,
  pageSize: 10,
  totalItems: 3,
  allowedUserCount: 100,
};
